export function issueHandler(payload) {
    let now = Date.now();
    let timeStampOffset = payload.clientTimestamp - payload.serverTimestamp;
    let timestamp = now - timeStampOffset;
    let closeIssue = payload.closeIssue ? parseInt(payload.closeIssue, 10) : 0;
    let issues = payload.issues.filter(i => i != null);
    let issueSetting = payload.issueSetting || { OldIssueLength: 20};
    let oldIssueLength = issueSetting.OldIssueLength || 20;

    let result = {
        now: now,
        waitingIssue: true,
        startTimestamp: 0,
        endTimestamp: 0,
        currentIssue: null,
        recentIssues: [],
        oldIssues: []
    };

    // 找出當前期號
    let index = issues.findIndex(i => {
        let nSerialNumber = parseInt(i.serialNumber, 10);
        return (isNaN(nSerialNumber) || nSerialNumber > closeIssue) && i.closeTimeStamp > timestamp;
    });
    if (index < 0) {
        issues.reverse();
        result.oldIssues = issues;
        return result;
    }

    if (issues[index].startTimeStamp <= timestamp) {

        // 當前期號進行中
        result.waitingIssue = false;
        result.startTimestamp = issues[index].startTimeStamp + timeStampOffset;
        result.endTimestamp = issues[index].closeTimeStamp + timeStampOffset;
        result.currentIssue = issues[index];
        result.recentIssues = issues.slice(index + 1);

        let oldIssues = issues.slice(0, index);
        oldIssues.reverse();
        result.oldIssues = oldIssues.slice(0, oldIssueLength);

    } else {

        // 等待開盤
        result.waitingIssue = true;
        result.startTimestamp = issues[index].startTimeStamp + timeStampOffset;
        result.endTimestamp = issues[index].startTimeStamp + timeStampOffset;
        result.currentIssue = null;
        result.recentIssues = issues.slice(index);

        let oldIssues = issues.slice(0, index);
        oldIssues.reverse();
        result.oldIssues = oldIssues.slice(0, oldIssueLength);
    }

    return result;
}

export class issueModel {
    constructor(data) {
        this.serialNumber = data.SerialNumber;
        this.originalWinningNumber = data.OriginalWinningNumber || '';
        this.winningNumber = data.WinningNumber || '';
        this.closeTimeStamp = data.CloseTimeStamp;
        this.startTimeStamp = data.StartTimeStamp;
        this.drawTimeStamp = data.DrawTimeStamp;
    }
}

export class issueHandleInfo {
    constructor(data) {
        this.categoryId = data.CategoryId;
        this.isMaintain = data.IsMaintain;
        this.isOfficialOffline = data.IsOfficialOffline;
        this.isMiaoMiao = data.IsMiaoMiao;
        this.dailyIssueCount = data.DailyIssueCount;
        this.lastIssue = (Array.isArray(data.LastIssue) ? (data.LastIssue || []).map(i => new issueModel(i)) : new issueModel(data.LastIssue || {}) );
        this.currentIssue = new issueModel(data.CurrentIssue || {});
        this.recentIssues = (data.RecentIssues || []).map(i => new issueModel(i));
        this.oldIssues = (data.OldIssues || []).map(i => new issueModel(i));

        this.serverTimestamp = data.DateTimeNow;
        this.clientTimestamp = Date.now();
        this.startTimestamp = 0;
        this.endTimestamp = 0;
        this.waitingIssue = !data.CurrentIssue;
        this.countdownLength = 0;
        this.countdownTotal = 0;
    }

    handleIssueChange(payload) {
        let issueHandleParam = {
            clientTimestamp: this.clientTimestamp,
            serverTimestamp: this.serverTimestamp,
            closeIssue: payload ? payload.closeIssue : null,
            issues: mergeIssues(this)
        };

        let result = issueHandler(issueHandleParam);
        this.waitingIssue = result.waitingIssue;
        this.startTimestamp = result.startTimestamp;
        this.endTimestamp = result.endTimestamp;
        this.currentIssue = result.currentIssue;
        this.recentIssues = result.recentIssues;
        this.oldIssues = result.oldIssues;
        this.countdownLength = Math.max(0, this.endTimestamp - Date.now());
        this.countdownTotal = Math.max(0, this.endTimestamp - this.startTimestamp);
    }
}

function mergeIssues(issueHandleInfo) {
    if (issueHandleInfo.oldIssues.length > 0) {
        let oldIssues = issueHandleInfo.oldIssues.slice();
        oldIssues.reverse();
        return [...oldIssues, issueHandleInfo.currentIssue, ...issueHandleInfo.recentIssues];
    }
    else {
        return [issueHandleInfo.currentIssue, ...issueHandleInfo.recentIssues];
    }
}